var _g, _path, _g2, _path2, _path3, _g3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_428_20225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1129 8.0576H11.8298V7.21239C11.8298 6.98823 11.7407 6.77325 11.5822 6.61474C11.4237 6.45624 11.2087 6.36719 10.9846 6.36719H7.60375C7.37958 6.36719 7.1646 6.45624 7.00609 6.61474C6.84759 6.77325 6.75854 6.98823 6.75854 7.21239V8.0576H6.47117C6.4353 8.0576 6.40091 8.07185 6.37555 8.09721C6.35019 8.12257 6.33594 8.15697 6.33594 8.19284V9.19018C6.33594 9.26498 6.39637 9.32541 6.47117 9.32541H6.75854V11.861C6.75854 12.0935 6.75854 12.2836 7.18114 12.2836V12.9175C7.18114 12.9736 7.2034 13.0273 7.24303 13.067C7.28266 13.1066 7.3364 13.1288 7.39244 13.1288H8.23765C8.29369 13.1288 8.34744 13.1066 8.38706 13.067C8.42669 13.0273 8.44895 12.9736 8.44895 12.9175V12.2836H10.1394V12.9175C10.1394 12.9736 10.1616 13.0273 10.2012 13.067C10.2409 13.1066 10.2946 13.1288 10.3507 13.1288H11.1959C11.2519 13.1288 11.3057 13.1066 11.3453 13.067C11.3849 13.0273 11.4072 12.9736 11.4072 12.9175V12.2836C11.8298 12.2836 11.8298 12.0935 11.8298 11.861V9.32541H12.1129C12.1499 9.32541 12.1854 9.31072 12.2115 9.28457C12.2377 9.25841 12.2524 9.22294 12.2524 9.18595C12.2524 9.14897 12.2377 9.1135 12.2115 9.08734C12.1854 9.06119 12.1499 9.04649 12.1129 9.04649C12.0759 9.04649 12.0405 9.06119 12.0143 9.08734C11.9882 9.1135 11.9735 9.14897 11.9735 9.18595C11.9735 9.22294 11.9882 9.25841 12.0143 9.28457C12.0405 9.31072 12.0759 9.32541 12.1129 9.32541C12.1499 9.32541 12.1854 9.31072 12.2115 9.28457C12.2377 9.25841 12.2524 9.22294 12.2524 9.18595V8.19706C12.2524 8.16007 12.2377 8.1246 12.2115 8.09845C12.1854 8.0723 12.1499 8.0576 12.1129 8.0576ZM8.44895 6.78979H10.1394V7.21239H8.44895V6.78979ZM7.60375 11.4384C7.49166 11.4384 7.38417 11.3939 7.30492 11.3147C7.22567 11.2354 7.18114 11.1279 7.18114 11.0158C7.18114 10.9037 7.22567 10.7963 7.30492 10.717C7.38417 10.6377 7.49166 10.5932 7.60375 10.5932C7.71583 10.5932 7.82332 10.6377 7.90257 10.717C7.98182 10.7963 8.02635 10.9037 8.02635 11.0158C8.02635 11.1279 7.98182 11.2354 7.90257 11.3147C7.82332 11.3939 7.71583 11.4384 7.60375 11.4384ZM7.18114 9.74802V7.635H11.4072V9.74802H7.18114ZM10.9846 11.4384C10.8725 11.4384 10.765 11.3939 10.6857 11.3147C10.6065 11.2354 10.562 11.1279 10.562 11.0158C10.562 10.9037 10.6065 10.7963 10.6857 10.717C10.765 10.6377 10.8725 10.5932 10.9846 10.5932C11.0966 10.5932 11.2041 10.6377 11.2834 10.717C11.3626 10.7963 11.4072 10.9037 11.4072 11.0158C11.4072 11.1279 11.3626 11.2354 11.2834 11.3147C11.2041 11.3939 11.0966 11.4384 10.9846 11.4384Z",
    fill: "#F6A300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_20225",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28051 9.1052L2.17808 9.16317L0.790063 6.17077L12.4766 0.75L15.3776 7.00438L6.3735 11.1809L5.43566 9.15905L4.28051 9.1052Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_20225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91285 12.2529C3.24956 10.823 3.18149 9.18808 3.72362 7.70793C4.26574 6.22777 5.37365 5.02359 6.80362 4.36031C8.23358 3.69702 9.86847 3.62895 11.3486 4.17108C12.8288 4.7132 14.033 5.82111 14.6962 7.25108",
    stroke: "#F6A300",
    strokeWidth: 0.950959
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90552 9.14991L3.43133 11.7354L4.90755 9.12128L1.90552 9.14991Z",
    fill: "#F6A300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_428_20225",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 8,
    width: 15,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3211 10.3948L16.4235 10.3368L17.8115 13.3292L6.125 18.75L3.22393 12.4956L12.2281 8.31906L13.1659 10.341L14.3211 10.3948Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_428_20225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6887 7.23924C15.352 8.66921 15.4201 10.3041 14.8779 11.7843C14.3358 13.2644 13.2279 14.4686 11.7979 15.1319C10.368 15.7952 8.73309 15.8632 7.25294 15.3211C5.77278 14.779 4.56861 13.6711 3.90532 12.2411",
    stroke: "#F6A300",
    strokeWidth: 0.950959
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6882 10.3501L15.1624 7.76457L13.6862 10.3787L16.6882 10.3501Z",
    fill: "#F6A300"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_428_20225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.76164,
    height: 6.76166,
    fill: "white",
    transform: "translate(5.91406 6.36719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompIcon);
export default __webpack_public_path__ + "static/media/comp_icon.2c6cf0ba27d2c4262524931816b7d0c5.svg";
export { ForwardRef as ReactComponent };